import * as React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import styled from 'styled-components';

import SidebarCtrl, { SidebarSection } from '@webapp/controllers/sidebar';
import { Translate } from 'react-localize-redux';

type UserProfileMenuSectionsType = {
  isPublishDisabled?: boolean;
  isBankingDisabled?: boolean;
};

export const getUserProfileMenuSections = ({
  isPublishDisabled = true,
  isBankingDisabled = false,
}: UserProfileMenuSectionsType): SidebarSection[] => [
  {
    path: '/user/general',
    label: <Translate id="DASHBOARD.NEW_DASHBOARD.USER.MENU.SETTINGS" />,
    noIcon: true,
  },
  {
    path: '/user/publishing',
    label: <Translate id="DASHBOARD.NEW_DASHBOARD.USER.MENU.PUBLISHING" />,
    noIcon: true,
    disabled: isPublishDisabled,
  },
  {
    path: '/user/banking',
    label: <Translate id="DASHBOARD.NEW_DASHBOARD.USER.MENU.WALLET" />,
    noIcon: true,
    disabled: isBankingDisabled,
  },
  {
    path: '/user/security',
    label: <Translate id="DASHBOARD.NEW_DASHBOARD.USER.MENU.SECURITY" />,
    noIcon: true,
  },
];

interface UserProfileSidebarCtrlProps {
  className?: string;
  isMobile: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export const UserProfileSidebarCtrl: React.FC<UserProfileSidebarCtrlProps> = ({
  className,
}) => {
  const userProfileMenuSections = React.useMemo(
    () => getUserProfileMenuSections({}),
    []
  );
  return (
    <div className={className}>
      <SidebarCtrl
        title={<Translate id="USER_PROFILE.SIDEBAR.TITLE" />}
        sections={userProfileMenuSections}
      />
    </div>
  );
};

export default connect(mapStateToProps)(styled(UserProfileSidebarCtrl)``);
